import React, { useState } from "react";
import { Users } from "lucide-react";
import GestionaleShell from "./GestionaleShell";
import GestCrudTable from "./GestCrudTable";

const FIELDS = [
  { key: "company", label: "Azienda", type: "text", required: true, span: 2 },
  { key: "type", label: "Tipologia", type: "select", options: [
    { value: "importer", label: "Importatore" },
    { value: "distributor", label: "Distributore" },
    { value: "horeca", label: "Horeca" },
    { value: "retail", label: "Retail" },
    { value: "other", label: "Altro" },
  ], defaultValue: "importer" },
  { key: "region", label: "Regione BR", type: "select", options: [
    { value: "", label: "—" }, { value: "SP", label: "São Paulo" }, { value: "RJ", label: "Rio de Janeiro" },
    { value: "MG", label: "Minas Gerais" }, { value: "RS", label: "Rio Grande do Sul" }, { value: "PR", label: "Paraná" },
    { value: "SC", label: "Santa Catarina" }, { value: "BA", label: "Bahia" }, { value: "DF", label: "Distrito Federal" },
    { value: "OUTRA", label: "Altra regione" },
  ], defaultValue: "" },
  { key: "contact_person", label: "Referente", type: "text" },
  { key: "contact_email", label: "Email", type: "text" },
  { key: "contact_phone", label: "Telefono", type: "text", hideInTable: true },
  { key: "expected_value_eur", label: "Valore atteso (€)", type: "number" },
  { key: "stage", label: "Stage", type: "select", statusTone: true, options: [
    { value: "lead", label: "Lead", tone: "stone" },
    { value: "sample", label: "Sample", tone: "blue" },
    { value: "quotation", label: "Quotation", tone: "blue" },
    { value: "negotiation", label: "Negotiation", tone: "amber" },
    { value: "po", label: "Ordine PO", tone: "gold" },
    { value: "shipment", label: "Spedito", tone: "gold" },
    { value: "reorder", label: "Riordino", tone: "emerald" },
    { value: "lost", label: "Perso", tone: "rose" },
  ], defaultValue: "lead" },
  { key: "notes", label: "Note", type: "textarea", hideInTable: true },
];

export default function CrmLeadsPage() {
  const [data, setData] = useState({ total: 0, pipeline_value_eur: 0, items: [] });
  const wonOrReorder = (data.items || []).filter(i => i.stage === "reorder").length;

  return (
    <GestionaleShell
      icon={Users}
      code="07"
      title="CRM B2B Brazil"
      subtitle="Pipeline LEAD → REORDER per importatori, distributori, Horeca e retail brasiliani."
      kpiBlocks={[
        { value: data.total || 0, label: "Lead totali" },
        { value: `€${Math.round((data.pipeline_value_eur || 0) / 1000)}k`, label: "Pipeline" },
      ]}
    >
      <GestCrudTable
        endpoint="/gestionale/crm-leads"
        fields={FIELDS}
        itemLabel="lead B2B"
        emptyHint="Aggiungi i tuoi primi contatti commerciali in Brasile."
        testIdPrefix="crm"
        onItemsLoaded={(d) => setData(d)}
        rowSummary={(items) => (
          <div className="flex flex-wrap gap-4 text-[11px] uppercase tracking-[0.18em]">
            <span className="text-stone-500">Pipeline aperta: <b className="text-stone-900">€{(data.pipeline_value_eur || 0).toLocaleString("it-IT")}</b></span>
            <span className="text-stone-500">Riordini: <b className="text-emerald-700">{wonOrReorder}</b></span>
            <span className="ml-auto text-stone-400">{items.length} record</span>
          </div>
        )}
      />
    </GestionaleShell>
  );
}
